const doc = [({"en":({"js":({"admin":({"user_elements":({"answer":({"this_answer_has_been_anonymized":"This answer has been anonymized.", "no_answer":"No answer given"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;